module.exports = __webpack_public_path__ + "static/media/i38.236fe673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i38.svg
// module id = 319
// module chunks = 8